import React, { useState } from 'react';
import './SimilarityWeights.css';

/**
 * Criterios de similitud simplificados.
 * Estos son los criterios principales que el algoritmo de similitud usa actualmente.
 */
const SIMILARITY_CRITERIA = [
  { key: 'part_type', label: 'Tipo de pieza', description: 'Mismo tipo (eje, engranaje, etc.)' },
  { key: 'diameter_range', label: 'Diámetro similar', description: 'Diámetro máximo ±20%' },
  { key: 'has_tallado', label: 'Tiene tallado', description: 'Ambas con/sin tallado' },
  { key: 'modulo', label: 'Módulo engranaje', description: 'Módulo similar ±10%' },
  { key: 'has_rectificado', label: 'Requiere rectificado', description: 'Ambas con/sin rectificado' },
  { key: 'has_chavetero', label: 'Tiene chavetero', description: 'Ambas con/sin chavetero' },
  { key: 'num_taladros', label: 'Nº taladros similar', description: 'Diferencia ±2 taladros' },
];

const DEFAULT_WEIGHTS = {
  part_type: 30,
  diameter_range: 15,
  has_tallado: 15,
  modulo: 10,
  has_rectificado: 10,
  has_chavetero: 10,
  num_taladros: 10,
};

const SimilarityWeights = ({ weights, onChange, onReset }) => {
  const [expanded, setExpanded] = useState(false);

  const handleWeightChange = (key, value) => {
    const numValue = parseInt(value, 10);
    onChange({ ...weights, [key]: numValue });
  };

  const totalWeight = Object.values(weights).reduce((sum, val) => sum + (val || 0), 0);
  const isValid = totalWeight === 100;

  return (
    <div className="similarity-weights">
      <div className="weights-header" onClick={() => setExpanded(!expanded)}>
        <div className="weights-header-left">
          <h4>Criterios de similitud</h4>
          <span className="weights-summary">
            {isValid ? 'Configurado' : `${totalWeight}% (debe ser 100%)`}
          </span>
        </div>
        <span className="expand-icon">{expanded ? '▲' : '▼'}</span>
      </div>

      {expanded && (
        <div className="weights-content">
          <p className="weights-description">
            Ajusta la importancia de cada criterio. Los pesos deben sumar 100%.
          </p>

          <div className="weights-grid">
            {SIMILARITY_CRITERIA.map(({ key, label, description }) => (
              <div key={key} className="weight-item">
                <div className="weight-info">
                  <span className="weight-label">{label}</span>
                  <span className="weight-desc">{description}</span>
                </div>
                <div className="weight-control">
                  <input
                    type="range"
                    min="0"
                    max="100"
                    step="5"
                    value={weights[key] || 0}
                    onChange={(e) => handleWeightChange(key, e.target.value)}
                    className="weight-slider"
                  />
                  <span className="weight-value">{weights[key] || 0}%</span>
                </div>
              </div>
            ))}
          </div>

          <div className="weights-footer">
            <div className={`total-weight ${isValid ? 'valid' : 'invalid'}`}>
              Total: {totalWeight}%
              {!isValid && <span className="weight-warning"> (ajusta para sumar 100%)</span>}
            </div>
            <button
              type="button"
              onClick={() => onChange({ ...DEFAULT_WEIGHTS })}
              className="btn-reset"
            >
              Restaurar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// Exportar también los defaults para usarlos en SimilaritySearchPage
export { DEFAULT_WEIGHTS };
export default SimilarityWeights;
